import React, { useRef, useEffect, useContext } from 'react'
import gsap from 'gsap'
import { StoreDispatch, StoreState } from '../../Store'
import {
  TransitionMaskWrapper,
  TransitionMaskBlock,
  TransitionMaskIcon,
  TransitionMaskLogo,
  TransitionMaskCircle,
} from './index.style'
import { animation } from '../../styles/vars/animation.style'

import Logo from '../svgs/Logo'
import LogoCircle from '../svgs/LogoCircle'

const TransitionMask = () => {
  const store = useContext(StoreState)
  const dispatch = useContext(StoreDispatch)
  const maskRef = useRef()

  useEffect(() => {
    const tl = gsap.timeline()

    if (store.showTransitionMask) {
      const mask = maskRef.current
      tl.to(mask, {
        opacity: 1,
        duration: animation.maskShowDuration,
        ease: 'power2.inOut',
        onComplete: () => {
          dispatch({ type: 'HIDE_MOBILE_NAV' })
        },
      })
    }

    if (!store.showTransitionMask) {
      const mask = maskRef.current
      tl.to(mask, {
        opacity: 0,
        delay: animation.maskHoldDuration,
        duration: animation.maskHideDuration,
        ease: 'power2.inOut',
        onStart: () => dispatch({ type: 'HIDE_MOBILE_NAV' }),
      })
    }

    return () => {
      if (tl) {
        tl.kill()
      }
    }
  }, [store.showTransitionMask, dispatch])

  return (
    <TransitionMaskWrapper show={store.showTransitionMask}>
      <TransitionMaskBlock ref={maskRef} backgroundColor={store.maskColor} />
      <TransitionMaskIcon>
        <TransitionMaskLogo show={store.showTransitionMask}>
          <Logo />
        </TransitionMaskLogo>
        <TransitionMaskCircle show={store.showTransitionMask}>
          <LogoCircle />
        </TransitionMaskCircle>
      </TransitionMaskIcon>
    </TransitionMaskWrapper>
  )
}

export default TransitionMask
